<template>
    <div class="payment-item-option">
        <div class="payment-item-option-details">
            <div class="payment-item-option-name">
                <div class="quantity" v-if="option.quantity > 1">{{ option.quantity }}x</div>
                {{ getNameInLocationLanguage(option, props.showInternalNames) }}
            </div>
            <div class="payment-item-option-price">
                <ItemTotalPrice
                    v-if="!option.isZeroPriceArticle"
                    class="payment-item-option-price"
                    :hasDiscount="option.hasDiscount"
                    :totalAmount="option.totalAmount"
                    :totalAmountAfterDiscount="option.totalAmountAfterDiscount"
                    :discountType="option.lastDiscountType"
                />
            </div>
        </div>
        <div class="subs" v-if="option.options.length">
            <PaymentItemOptionGroup
                v-for="optionGroup in option.options"
                :key="optionGroup.id"
                :optionGroup="optionGroup"
                :showInternalNames="props.showInternalNames"
                :alwaysShowGroupName="props.alwaysShowGroupName"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IPaymentItemOption } from "@/data/model/Order";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";

    import ItemTotalPrice from "@/components/order/ItemTotalPrice.vue";
    import PaymentItemOptionGroup from "@/components/order/PaymentItemOptionGroup.vue";

    const props = defineProps<{
        option: IPaymentItemOption;
        showInternalNames: boolean;
        alwaysShowGroupName?: boolean;
    }>();
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .payment-item-option {
        font-size: 12px;
        line-height: 1.666em;

        > .payment-item-option-details {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;

            > .payment-item-option-name {
                > .quantity {
                    display: inline-block;
                    vertical-align: top;
                    padding-right: 0.25em;
                    font-weight: 600;
                }

                flex-grow: 1;
            }

            > .payment-item-option-price {
                flex: 0 0 auto;
            }
        }
        > .subs {
            padding: 0.1666em 0;
            padding-left: 1em;
        }
    }
</style>
